import { createContext, useContext } from "react";

/**
 * SERV-3232: a drawer opened on a merged-view row acts in that row's entity without touching the
 * record store, because the list underneath keeps polling in the merged scope. The drawer
 * provides the row's tenant here and the hooks it renders send it per call.
 */
export const ActingEntityContext = createContext<string | undefined>(undefined);

export const useActingEntityId = (): string | undefined => useContext(ActingEntityContext);
